<content>
    <section>
        <form [formGroup]="emailSubscriptionForm" [ngClass]="{ 'show-error':showError }">
            <div class="entry-4-modal">
                <label>{{ 'emailSubscription.sendEmailReport' | translate }} *</label>
                <app-filterable-list class="short-list" [itemsList]="alertasEmail"
                    [selectedItem]="emailSubscriptionForm.get('alertasEmail')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.sncReimpresiones' | translate }} *</label>
                <app-filterable-list class="short-list" [itemsList]="reimpresionesSnc" [selectedItem]="emailSubscriptionForm.get('reimpresionesSnc')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.numReimpresiones' | translate }} *</label>
                <app-filterable-list class="short-list" [itemsList]="reimpresionesNum" [selectedItem]="emailSubscriptionForm.get('reimpresionesNum')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label style="white-space: nowrap;">{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.excesoDesignaciones' | translate }} *</label>
                <app-filterable-list class="short-list" [itemsList]="excesosDesignaciones" [selectedItem]="emailSubscriptionForm.get('excesosDesignaciones')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal alignment-start">
                <input type="checkbox" id="envio-inmediato" formControlName="envioInmediato">
                <label for="envio-inmediato">{{ 'emailSubscription.sendImmediately' | translate}}</label>
            </div>
        </form>
    </section>
</content>

<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
    <button (click)="save()">{{ 'global.guardar' | translate }}</button>
</footer>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>